export const MIMEtypes = new Map<string, string>()

MIMEtypes.set('abs', 'audio/x-mpeg')
MIMEtypes.set('ai', 'application/postscript')
MIMEtypes.set('aif', 'audio/x-aiff')
MIMEtypes.set('aifc', 'audio/x-aiff')
MIMEtypes.set('aiff', 'audio/x-aiff')
MIMEtypes.set('aim', 'application/x-aim')
MIMEtypes.set('art', 'image/x-jg')
MIMEtypes.set('asf', 'video/x-ms-asf')
MIMEtypes.set('asx', 'video/x-ms-asf')
MIMEtypes.set('au', 'audio/basic')
MIMEtypes.set('avi', 'video/x-msvideo')
MIMEtypes.set('avx', 'video/x-rad-screenplay')
MIMEtypes.set('bcpio', 'application/x-bcpio')
MIMEtypes.set('bin', 'application/octet-stream')
MIMEtypes.set('bmp', 'image/bmp')
MIMEtypes.set('body', 'text/html')
MIMEtypes.set('cdf', 'application/x-cdf')
MIMEtypes.set('cer', 'application/pkix-cert')
MIMEtypes.set('class', 'application/java')
MIMEtypes.set('cpio', 'application/x-cpio')
MIMEtypes.set('csh', 'application/x-csh')
MIMEtypes.set('css', 'text/css')
MIMEtypes.set('dib', 'image/bmp')
MIMEtypes.set('doc', 'application/msword')
MIMEtypes.set('dtd', 'application/xml-dtd')
MIMEtypes.set('dv', 'video/x-dv')
MIMEtypes.set('dvi', 'application/x-dvi')
MIMEtypes.set('eot', 'application/vnd.ms-fontobject')
MIMEtypes.set('eps', 'application/postscript')
MIMEtypes.set('etx', 'text/x-setext')
MIMEtypes.set('exe', 'application/octet-stream')
MIMEtypes.set('gif', 'image/gif')
MIMEtypes.set('gtar', 'application/x-gtar')
MIMEtypes.set('gz', 'application/x-gzip')
MIMEtypes.set('hdf', 'application/x-hdf')
MIMEtypes.set('hqx', 'application/mac-binhex40')
MIMEtypes.set('htc', 'text/x-component')
MIMEtypes.set('htm', 'text/html')
MIMEtypes.set('html', 'text/html')
MIMEtypes.set('ief', 'image/ief')
MIMEtypes.set('jad', 'text/vnd.sun.j2me.app-descriptor')
MIMEtypes.set('jar', 'application/java-archive')
MIMEtypes.set('java', 'text/x-java-source')
MIMEtypes.set('jnlp', 'application/x-java-jnlp-file')
MIMEtypes.set('jpe', 'image/jpeg')
MIMEtypes.set('jpeg', 'image/jpeg')
MIMEtypes.set('jpg', 'image/jpeg')
MIMEtypes.set('js', 'application/javascript')
MIMEtypes.set('jsf', 'text/plain')
MIMEtypes.set('json', 'application/json')
MIMEtypes.set('jspf', 'text/plain')
MIMEtypes.set('kar', 'audio/midi')
MIMEtypes.set('latex', 'application/x-latex')
MIMEtypes.set('m3u', 'audio/x-mpegurl')
MIMEtypes.set('mac', 'image/x-macpaint')
MIMEtypes.set('man', 'text/troff')
MIMEtypes.set('mathml', 'application/mathml+xml')
MIMEtypes.set('me', 'text/troff')
MIMEtypes.set('mid', 'audio/midi')
MIMEtypes.set('midi', 'audio/midi')
MIMEtypes.set('mif', 'application/x-mif')
MIMEtypes.set('mov', 'video/quicktime')
MIMEtypes.set('movie', 'video/x-sgi-movie')
MIMEtypes.set('mp1', 'audio/mpeg')
MIMEtypes.set('mp2', 'audio/mpeg')
MIMEtypes.set('mp3', 'audio/mpeg')
MIMEtypes.set('mp4', 'video/mp4')
MIMEtypes.set('mpa', 'audio/mpeg')
MIMEtypes.set('mpe', 'video/mpeg')
MIMEtypes.set('mpeg', 'video/mpeg')
MIMEtypes.set('mpega', 'audio/x-mpeg')
MIMEtypes.set('mpg', 'video/mpeg')
MIMEtypes.set('mpv2', 'video/mpeg2')
MIMEtypes.set('ms', 'application/x-wais-source')
MIMEtypes.set('nc', 'application/x-netcdf')
MIMEtypes.set('oda', 'application/oda')
MIMEtypes.set('odb', 'application/vnd.oasis.opendocument.database')
MIMEtypes.set('odc', 'application/vnd.oasis.opendocument.chart')
MIMEtypes.set('odf', 'application/vnd.oasis.opendocument.formula')
MIMEtypes.set('odg', 'application/vnd.oasis.opendocument.graphics')
MIMEtypes.set('odi', 'application/vnd.oasis.opendocument.image')
MIMEtypes.set('odm', 'application/vnd.oasis.opendocument.text-master')
MIMEtypes.set('odp', 'application/vnd.oasis.opendocument.presentation')
MIMEtypes.set('ods', 'application/vnd.oasis.opendocument.spreadsheet')
MIMEtypes.set('odt', 'application/vnd.oasis.opendocument.text')
MIMEtypes.set('otg', 'application/vnd.oasis.opendocument.graphics-template')
MIMEtypes.set('oth', 'application/vnd.oasis.opendocument.text-web')
MIMEtypes.set('otp', 'application/vnd.oasis.opendocument.presentation-template')
MIMEtypes.set('ots', 'application/vnd.oasis.opendocument.spreadsheet-template')
MIMEtypes.set('ott', 'application/vnd.oasis.opendocument.text-template')
MIMEtypes.set('ogx', 'application/ogg')
MIMEtypes.set('ogv', 'video/ogg')
MIMEtypes.set('oga', 'audio/ogg')
MIMEtypes.set('ogg', 'audio/ogg')
MIMEtypes.set('otf', 'application/x-font-opentype')
MIMEtypes.set('spx', 'audio/ogg')
MIMEtypes.set('flac', 'audio/flac')
MIMEtypes.set('anx', 'application/annodex')
MIMEtypes.set('axa', 'audio/annodex')
MIMEtypes.set('axv', 'video/annodex')
MIMEtypes.set('xspf', 'application/xspf+xml')
MIMEtypes.set('pbm', 'image/x-portable-bitmap')
MIMEtypes.set('pct', 'image/pict')
MIMEtypes.set('pdf', 'application/pdf')
MIMEtypes.set('pgm', 'image/x-portable-graymap')
MIMEtypes.set('pic', 'image/pict')
MIMEtypes.set('pict', 'image/pict')
MIMEtypes.set('pls', 'audio/x-scpls')
MIMEtypes.set('png', 'image/png')
MIMEtypes.set('pnm', 'image/x-portable-anymap')
MIMEtypes.set('pnt', 'image/x-macpaint')
MIMEtypes.set('ppm', 'image/x-portable-pixmap')
MIMEtypes.set('ppt', 'application/vnd.ms-powerpoint')
MIMEtypes.set('pps', 'application/vnd.ms-powerpoint')
MIMEtypes.set('ps', 'application/postscript')
MIMEtypes.set('psd', 'image/vnd.adobe.photoshop')
MIMEtypes.set('qt', 'video/quicktime')
MIMEtypes.set('qti', 'image/x-quicktime')
MIMEtypes.set('qtif', 'image/x-quicktime')
MIMEtypes.set('ras', 'image/x-cmu-raster')
MIMEtypes.set('rdf', 'application/rdf+xml')
MIMEtypes.set('rgb', 'image/x-rgb')
MIMEtypes.set('rm', 'application/vnd.rn-realmedia')
MIMEtypes.set('roff', 'text/troff')
MIMEtypes.set('rtf', 'application/rtf')
MIMEtypes.set('rtx', 'text/richtext')
MIMEtypes.set('sfnt', 'application/font-sfnt')
MIMEtypes.set('sh', 'application/x-sh')
MIMEtypes.set('shar', 'application/x-shar')
MIMEtypes.set('sit', 'application/x-stuffit')
MIMEtypes.set('snd', 'audio/basic')
MIMEtypes.set('src', 'application/x-wais-source')
MIMEtypes.set('sv4cpio', 'application/x-sv4cpio')
MIMEtypes.set('sv4crc', 'application/x-sv4crc')
MIMEtypes.set('svg', 'image/svg+xml')
MIMEtypes.set('svgz', 'image/svg+xml')
MIMEtypes.set('swf', 'application/x-shockwave-flash')
MIMEtypes.set('t', 'text/troff')
MIMEtypes.set('tar', 'application/x-tar')
MIMEtypes.set('tcl', 'application/x-tcl')
MIMEtypes.set('tex', 'application/x-tex')
MIMEtypes.set('texi', 'application/x-texinfo')
MIMEtypes.set('texinfo', 'application/x-texinfo')
MIMEtypes.set('tif', 'image/tiff')
MIMEtypes.set('tiff', 'image/tiff')
MIMEtypes.set('tr', 'text/troff')
MIMEtypes.set('tsv', 'text/tab-separated-values')
MIMEtypes.set('ttf', 'application/x-font-ttf')
MIMEtypes.set('txt', 'text/plain')
MIMEtypes.set('ulw', 'audio/basic')
MIMEtypes.set('ustar', 'application/x-ustar')
MIMEtypes.set('vxml', 'application/voicexml+xml')
MIMEtypes.set('xbm', 'image/x-xbitmap')
MIMEtypes.set('xht', 'application/xhtml+xml')
MIMEtypes.set('xhtml', 'application/xhtml+xml')
MIMEtypes.set('xls', 'application/vnd.ms-excel')
MIMEtypes.set('xml', 'application/xml')
MIMEtypes.set('xpm', 'image/x-xpixmap')
MIMEtypes.set('xsl', 'application/xml')
MIMEtypes.set('xslt', 'application/xslt+xml')
MIMEtypes.set('xul', 'application/vnd.mozilla.xul+xml')
MIMEtypes.set('xwd', 'image/x-xwindowdump')
MIMEtypes.set('vsd', 'application/vnd.visio')
MIMEtypes.set('wav', 'audio/x-wav')
MIMEtypes.set('wbmp', 'image/vnd.wap.wbmp')
MIMEtypes.set('wml', 'text/vnd.wap.wml')
MIMEtypes.set('wmlc', 'application/vnd.wap.wmlc')
MIMEtypes.set('wmls', 'text/vnd.wap.wmlsc')
MIMEtypes.set('wmlscriptc', 'application/vnd.wap.wmlscriptc')
MIMEtypes.set('wmv', 'video/x-ms-wmv')
MIMEtypes.set('woff', 'application/font-woff')
MIMEtypes.set('woff2', 'application/font-woff2')
MIMEtypes.set('wrl', 'model/vrml')
MIMEtypes.set('wspolicy', 'application/wspolicy+xml')
MIMEtypes.set('z', 'application/x-compress')
MIMEtypes.set('zip', 'application/zip')
